import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubHeaderData } from '../../models';
import { UserMatrixModel } from '../../models/user-matrix-model';
import { UserPermissions } from 'src/app/Modules/management/models/organization/user-permissions.model';
import { TranslocoService } from '@jsverse/transloco';
@Component({
    selector: 'app-matrix',
    templateUrl: './matrix.component.html',
    styleUrls: ['./matrix.component.scss'],
    standalone: false
})
export class MatrixComponent implements OnInit {
    tooltip_position = 'above';
    subHeaderData: SubHeaderData;
    newlyAddedMatrix: UserMatrixModel;
    userPermissions: UserPermissions[];

    constructor(private router: Router,
             private translocoService: TranslocoService) {}

    ngOnInit(): void {
        if (localStorage.getItem('currentInstanceId') === null || localStorage.getItem('currentInstanceId') === undefined) {
            this.router.navigate(['/organization']);
        }
        this.subHeaderData = this.setSubHeaderValues();
    }
    setSubHeaderValues(): SubHeaderData {
        let headerData = new SubHeaderData();
        headerData.displayText = this.translocoService.translate('HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.MATRIX');
        headerData.displayTitle = 'Joint Matrics';
        headerData.disableActions = true;
        headerData.defaultImageSrc = '../../../../../../assets/media/logos/matrix-black.png';
        headerData.mouseOverImageSrc = '../../../../../../assets/media/logos/matrix-yellow.png';
        return headerData;
    }

    // transfering newly added matrix data
    addMatrix(eventData) {
        this.newlyAddedMatrix = eventData;
    }
}
